import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { Check, BookOpen, Brain, Code2, Rocket, AlertTriangle } from 'lucide-react';

const objectives = [
  { icon: BookOpen, text: 'Explain the architecture and training of modern LLMs', color: 'primary' },
  { icon: Brain, text: 'Understand how reasoning capabilities emerge in language models', color: 'secondary' },
  { icon: Code2, text: 'Implement basic reasoning chains for problem-solving', color: 'accent' },
  { icon: Rocket, text: 'Apply reasoning models to NOC automation scenarios', color: 'chart-4' },
  { icon: AlertTriangle, text: 'Critically evaluate reasoning model performance and limitations', color: 'chart-5' },
];

const ObjectivesSlide = () => {
  return (
    <SlideLayout>
      <SlideTitle 
        subtitle="By the end of this lecture, you will be able to:"
      >
        Learning Objectives
      </SlideTitle>
      
      <SlideContent>
        <div className="space-y-4">
          {objectives.map((objective, index) => {
            const Icon = objective.icon;
            return (
              <div 
                key={index}
                className="slide-card flex items-start gap-4 hover:border-primary/30 transition-colors"
              >
                <div className={`p-2 rounded-lg bg-${objective.color}/10 border border-${objective.color}/20`}>
                  <Icon className={`w-5 h-5 text-${objective.color}`} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-accent flex-shrink-0" />
                    <p className="text-foreground">{objective.text}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default ObjectivesSlide;
